// extracted by mini-css-extract-plugin
export default {"loginFailWrap":"SocialLoginFailed_loginFailWrap__5hjh2"};